import { useState } from "react";
import { LoadingDashed } from "react-huge-icons/solid";

interface ButtonProps {
    iconSrc?: string;
    icon?: (props: any) => JSX.Element;
    light?: boolean;
    link?: boolean;
    children?: any;
    type?: "button" | "submit" | "reset";
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    selected?: boolean;
    sm?: boolean;
    fontLight?: boolean;
    px?: number;
    disabled?: boolean;
    loading?: boolean;
    className?: string;
}

const Button: React.FC<ButtonProps> = ({ loading, iconSrc, className = "", disabled, light, children, type, onClick, selected, sm, icon, link, fontLight, px, }) => {
    const Icon = icon;


    return (
        <button
            disabled={disabled || loading}
            style={{ paddingInline: px, backgroundColor: (disabled || loading) ? 'rgb(111 118 126)' : link ? "#ffffff00" : light ? '#ffffffff' : 'blue' }}
            onClick={onClick}
            type={type || "button"}
            className={`
        ${!light ? 'bg-blue text-white' :
                    'gap-x-2 border-2 text-dark border-[#EFEFEF]'}
            ${sm ? 'py-1.5 rounded-lg' : 'py-3 rounded-xl'} px-2 flex flex-1 justify-center items-center text-base w-full font-bold
            font-Inter
            ${selected && 'border-blue border-2'}
            ${link && 'bg-[#ffffff]/0 border-0 font-semibold'}
            ${(disabled || loading) && 'bg-dark-primary text-dark'}
         ${className}`}>
            {iconSrc && <img src={iconSrc} width={24} height={24} />}
            {Icon && <Icon className="h-6 w-6 " />}
            <span className={`h-[22px] w-auto ${fontLight && 'font-medium'} whitespace-nowrap flex items-center justify-center ${link && !loading && 'text-blue'}`}>
                {loading ? <LoadingDashed className='animate-spin' /> : children}
            </span>
        </button>
    );
}

export default Button;